/* [PATCH napake-email-fe v1] Stikalo e-poštnega obveščanja na strani Prijave napak.
   GET/PUT /napake/obvescanje — privzeto vklopljeno (odloča strežnik: ni zapisa = vklopljeno). */
import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function NapakeObvescanje() {
  const [vklopljeno, setVklopljeno] = useState<boolean | null>(null);
  const [jeSuperadmin, setJeSuperadmin] = useState(false);
  const [shranjujem, setShranjujem] = useState(false);
  const [napaka, setNapaka] = useState('');

  useEffect(() => {
    let ziv = true;
    api.get('/napake/obvescanje')
      .then((r: any) => {
        const d = r && r.data ? r.data : r;
        if (!ziv) return;
        setVklopljeno(!!(d && d.vklopljeno));
        setJeSuperadmin(!!(d && d.je_superadmin));
      })
      .catch(() => { if (ziv) setVklopljeno(null); });
    return () => { ziv = false; };
  }, []);

  if (vklopljeno === null) return null;

  const preklopi = async () => {
    const nova = !vklopljeno;
    setShranjujem(true);
    setNapaka('');
    try {
      await api.put('/napake/obvescanje', { vklopljeno: nova });
      setVklopljeno(nova);
    } catch {
      setNapaka('Shranjevanje ni uspelo');
    } finally {
      setShranjujem(false);
    }
  };

  const namig = jeSuperadmin
    ? 'Nove prijave in odgovori uporabnikov na e-pošto podpore'
    : 'Odgovori podpore na vaše prijave na vaš e-naslov'; // [PATCH napake-email v1b]

  return (
    <label
      className="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer select-none"
      title={namig}
    >
      <input
        type="checkbox"
        className="h-4 w-4 accent-blue-600"
        checked={vklopljeno}
        disabled={shranjujem}
        onChange={preklopi}
      />
      <span>Obveščanje po e-pošti</span>
      {napaka ? <span className="text-red-600 text-xs">{napaka}</span> : null}
    </label>
  );
}
